module.exports = __webpack_public_path__ + "img/recruittext-sm.6ec9dbe4.png";